import {
  IUserClient,
  IUserClientData,
  IUserClientSubclient,
  UserClientSubclient,
} from "@/entities";

export class UserClient implements IUserClient {
  readonly id?: number;
  readonly oidSol?: string;
  readonly codeSol?: string;
  readonly idSmartcash?: string;
  readonly uniqueCode?: string;
  readonly description?: string;
  readonly active?: boolean;
  readonly subclients?: IUserClientSubclient[];

  constructor(data: IUserClientData) {
    this.id = data.id;
    this.oidSol = data.oidSol;
    this.codeSol = data.codeSol;
    this.idSmartcash = data.idSmartcash;
    this.uniqueCode = data.uniqueCode;
    this.description = data.description;
    this.active = data.active;

    this.subclients = data.subclients?.map((subclient) => new UserClientSubclient(subclient));
  }
}
